import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/display.css'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/element-beauty.css'


Vue.use(Element)
